import Vapi from "vuex-rest-api"
import ArrivalDeparture from "@/components/ArrivalsDepartures/models/ArrivalDeparture"
import AppEvents from '@/AppEvents';

const arrivalDepartureApi = new Vapi({
    baseURL: process.env.VUE_APP_API_HOST + "/api/trip",
    state: {
        arrivalsDepartures: [],
    }
})
// Deprecated
// .get({
//     action: "getAllArrivalDepartures",
//     property: "arrivalsDepartures",
//     path: "/arrivalDepartures",
//     onSuccess: (state, payload, axios) => {
//         // console.log("getAllArrivalDepartures onSuccess", state, payload.data);
//         state.arrivalsDepartures = payload.data.map(s => ArrivalDeparture.fromApi(s));
//         // console.log("state.arrivalsDepartures is now:", state.arrivalsDepartures);
//     },
//     onError: (state: any, error: any, axios: any) => {
//         AppEvents.handleApiError(error);
//     }
// })
.get({
    action: "getDestinationArrivalDepartures",
    property: "arrivalsDepartures",
    path: ({ destinationId, refreshCache }) => 
        ("/arrivalDepartures/destination/" + destinationId + (refreshCache ? '?refreshCache=true' : '')),
    onSuccess: (state, payload, axios) => {
        // console.log("getDestinationArrivalDepartures onSuccess", state, payload.data);
        const apiADs: any[] = payload.data;
        apiADs.forEach((apiAD: any) => {
            const newAD = ArrivalDeparture.fromApi(apiAD);
            const index: number = state.arrivalsDepartures.findIndex((AD: ArrivalDeparture) => AD.id === newAD.id);
            if (index > -1){
                // arrivalDeparture already exists, update props
                Object.assign(state.arrivalsDepartures[index], newAD);
            } else {
                // arrivalDeparture does not exists, push it to the store
                state.arrivalsDepartures.push(newAD);
            }
        });
    },
    onError: (state: any, error: any, axios: any) => {
        AppEvents.handleApiError(error);
    }
})
.put({
    action: "setComplete",
    property: "arrivalDepartureCompleted",
    path: "/arrivalDepartures/setComplete",
    onSuccess: (state, payload, axios) => {
        const arrivalDeparture: ArrivalDeparture = ArrivalDeparture.fromApi(payload.data);
        const index: number = state.arrivalsDepartures.findIndex((AD: ArrivalDeparture) => 
            AD.tripId === arrivalDeparture.tripId && 
            AD.arrivalDepartureType === arrivalDeparture.arrivalDepartureType
        );
        if (index === -1){
            throw new Error("There was a problem while setting the arrival/departure as complete.")
        }
        Object.assign(state.arrivalsDepartures[index], arrivalDeparture);
    },
    onError: (state: any, error: any, axios: any) => {
        AppEvents.handleApiError(error);
    }
})
.put({
    action: "setIncomplete",
    property: "arrivalDepartureIncomplete",
    path: "/arrivalDepartures/setIncomplete",
    onSuccess: (state, payload, axios) => {
        const arrivalDeparture: ArrivalDeparture = ArrivalDeparture.fromApi(payload.data);
        const index: number = state.arrivalsDepartures.findIndex((AD: ArrivalDeparture) => 
            AD.tripId === arrivalDeparture.tripId && 
            AD.arrivalDepartureType === arrivalDeparture.arrivalDepartureType
        );
        if (index === -1){
            throw new Error("There was a problem while setting the arrival/departure as incomplete.")
        }
        Object.assign(state.arrivalsDepartures[index], arrivalDeparture);
    },
    onError: (state: any, error: any, axios: any) => {
        AppEvents.handleApiError(error);
    }
})
.put({
    action: "cancel",
    property: "arrivalDepartureCancelled",
    path: "/arrivalDepartures/cancel",
    onSuccess: (state, payload, axios) => {
        const arrivalDeparture: ArrivalDeparture = ArrivalDeparture.fromApi(payload.data);
        const index: number = state.arrivalsDepartures.findIndex((AD: ArrivalDeparture) => 
            AD.tripId === arrivalDeparture.tripId && 
            AD.arrivalDepartureType === arrivalDeparture.arrivalDepartureType
        );
        if (index === -1){
            throw new Error("There was a problem while sending the arrival/departure cancellation request'.")
        }
        Object.assign(state.arrivalsDepartures[index], arrivalDeparture);
    },
    onError: (state: any, error: any, axios: any) => {
        AppEvents.handleApiError(error);
    }
})
   
const arrivalDepartureStore = arrivalDepartureApi.getStore();
(arrivalDepartureStore as any).namespaced = true;

export default arrivalDepartureStore;
